import { Link, useRouter } from '@tanstack/react-router';
import { Banner, Button, EmptyState } from '@meshble/molo';
import { Warn } from '../icons';
import { t } from '../lib/lingua';

/**
 * Rotta inesistente.
 *
 * Senza, un URL sbagliato dava una pagina bianca: il ripiego dell'hub serve
 * index.html per qualunque percorso — è quello che permette di ricaricare
 * `/orgs/acme/servers` — quindi il "non trovato" può dirlo solo il router.
 */
export function NonTrovato() {
  return (
    <div className="md-content">
      <EmptyState
        icon={<Warn />}
        title={t('Questa pagina non esiste')}
        action={
          <Link to="/">
            <Button variant="filled">{t('Vai ai server')}</Button>
          </Link>
        }
      >
        {t("L'indirizzo non corrisponde a nessuna schermata. Può essere un link vecchio, o un identificativo copiato a metà.")}
      </EmptyState>
    </div>
  );
}

/**
 * Un'eccezione dentro un componente.
 *
 * Senza questo, React smonta l'albero e lo schermo resta vuoto senza dire
 * niente: chi lo vede non sa se il pannello è rotto o se sta ancora caricando.
 * Il messaggio si mostra perché su un pannello interno serve a chi lo legge —
 * su un prodotto pubblico sarebbe da nascondere.
 */
export function Errore({ error, reset }: { error: Error; reset?: () => void }) {
  const router = useRouter();
  return (
    <div className="md-content">
      <div className="md-stack">
        <Banner
          tone="error"
          icon={<Warn />}
          title={t('Questa schermata ha avuto un problema')}
          action={
            <div className="md-stack__inline">
              <Button
                variant="text"
                onClick={() => {
                  // reset rimonta il sottoalbero; invalidate ricarica i dati.
                  // Senza il secondo, un errore causato da una query rotta
                  // tornerebbe identico al primo rimontaggio.
                  reset?.();
                  void router.invalidate();
                }}
              >
                {t('Riprova')}
              </Button>
              <Button variant="outlined" onClick={() => location.reload()}>
                {t('Ricarica')}
              </Button>
            </div>
          }
        >
          {error.message || t('Nessun dettaglio disponibile.')}
        </Banner>
      </div>
    </div>
  );
}
